import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {getUserGrade} from "../../api/apiClient";

const ComboUserGrade = ({
                          propLabel = '접속 권한',
                          propOnChange = null,
                          propValue
                        }) => {

  /* 목록 data */
  const [stList, setList] = useState([]);

  /* 목록 갱신 */
  const updateList = () => {
    getUserGrade()
        .then((res) => {
              // console.log(res.data.data.list);
              setList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateList();
  }, []);

  return (
      <Form.Group as={Row} controlId='userGrade'>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propLabel}
        </Form.Label>
        <Col md={9}>
          <Form.Select
              className={"input input-select"}
              onChange={propOnChange}
              defaultValue={propValue}
              key={propValue}
          >
            <option value={""}>선택</option>
            {Array.isArray(stList) ?
                (stList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}

          </Form.Select>
        </Col>
      </Form.Group>
  );
};

export default ComboUserGrade;